<template>
  <owa-page
    ref="pageRef"
    view-slug="home"
    :is-showing-new-pack-notice="false"
    :is-showing-build-awesome-kickstarter-notice="false"
    :is-build-awesome-icon-clickable="true"
    @reopen-ba-modal="showBuildAwesomeKickstarterModal"
  >
    <owa-page-header
      slot="header"
      key="header"
    />

    <main
      slot="content"
      role="main"
      style="
        --button-border-radius: var(--card-border-radius);
        --card-margin-bottom: 2em;
        --grid-gutter-x-width: 1rem;
        --h4-font-size: 1.125em;
        --h4-margin-bottom: 0.625em;
        --headings-font-weight: 700;
      "
    >
      <hero />

      <div
        ref="StickyElementParent"
        class="container"
      >
        <home-nav :is-sticky-element-stuck="isStickyElementStuck" />

        <span
          ref="StickyElementSentinel"
          aria-hidden="true"
          class="sticky-element-sentinel"
        ></span>

        <start-free v-if="!isSignedIn" />

        <fa7-pro />

        <pro-plus />

        <tech />

        <styling />

        <plan-compare />
      </div>

      <open-source />
      <logos ref="logos" />

      <modal-build-awesome-kickstarter
        :is-showing="isShowingBuildAwesomeKickstarterModal"
        @close-modal="hideBuildAwesomeKickstarterModal"
      />
    </main>

    <owa-page-footer slot="footer" />
  </owa-page>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Hero from './sections/Hero'
  import HomeNav from './sections/HomeNav'
  import StartFree from './sections/StartFree'
  import Fa7Pro from './sections/Fa7Pro'
  import ProPlus from './sections/ProPlus'
  import Tech from './sections/Tech'
  import Styling from './sections/Styling'
  import PlanCompare from './sections/PlanCompare'
  import OpenSource from './sections/OpenSource'
  import Logos from './sections/Logos'
  import ModalBuildAwesomeKickstarter from './components/ModalBuildAwesomeKickstarter'
  import { EventTrackingMixin, StickyElementMixin } from 'app/mixins'

  export default {
    name: 'Home',

    components: {
      Hero,
      HomeNav,
      StartFree,
      Fa7Pro,
      ProPlus,
      Tech,
      Styling,
      PlanCompare,
      OpenSource,
      Logos,
      ModalBuildAwesomeKickstarter
    },

    mixins: [EventTrackingMixin, StickyElementMixin],

    data() {
      return {
        isShowingBuildAwesomeKickstarterModal: false
      }
    },

    computed: {
      ...mapGetters('subscriptions', ['currentSubscription']),

      isSignedIn() {
        return this.$route.meta.isSignedIn
      },

      nextUrl() {
        const { origin } = window.location
        return `${origin}${this.$route.query.next}`
      }
    },

    mounted() {
      this.$forceUpdate()
      this.$posthog.capture('home_view', this.determinationsEventProps)
      // this.isShowingBuildAwesomeKickstarterModal = !document.cookie.includes('showBuildAwesomeKickstarterModal')
    },

    methods: {
      showBuildAwesomeKickstarterModal() {
        this.isShowingBuildAwesomeKickstarterModal = true
      },

      hideBuildAwesomeKickstarterModal() {
        this.isShowingBuildAwesomeKickstarterModal = false
        document.cookie = `showBuildAwesomeKickstarterModal=false; expires=${new Date('2026-03-31T18:00:00Z').toUTCString()}; path=/`
      }
    }
  }
</script>
